import { render, staticRenderFns } from "./ContractsRecordView.vue?vue&type=template&id=f05b28c2"
import script from "./ContractsRecordView.vue?vue&type=script&lang=js"
export * from "./ContractsRecordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports